interface Props {
  aiAnswer: string | null
  contextSnippet: string | null
  competitorMentions: string[]
  mentioned: boolean
  rankPosition: number | null
  sentiment: string | null
  keyword: string
  model: string
  onClose: () => void
}

export function RawResponseModal({
  aiAnswer,
  contextSnippet,
  competitorMentions,
  mentioned,
  rankPosition,
  sentiment,
  keyword,
  model,
  onClose,
}: Props) {
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-surface-container border border-outline-variant/20 rounded-xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-outline-variant/10">
          <div>
            <p className="text-xs font-mono text-outline uppercase tracking-widest mb-0.5">AI Response</p>
            <p className="text-sm text-white">
              <span className="text-on-surface-variant">{model}</span>
              {' · '}
              <span className="italic">{keyword}</span>
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-outline hover:text-white transition-colors text-xl leading-none"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-5 space-y-4">
          {aiAnswer && (
            <div>
              <p className="text-xs font-mono text-outline uppercase tracking-widest mb-2">What the AI said</p>
              <p className="text-sm text-on-surface-variant leading-relaxed bg-surface-container-high rounded-lg px-4 py-3">
                {aiAnswer}
              </p>
            </div>
          )}

          <div className="flex items-center gap-3">
            <span className="text-xs font-mono text-outline uppercase tracking-widest">Mentioned</span>
            <span className={`text-sm font-mono font-bold ${mentioned ? 'text-secondary' : 'text-error'}`}>
              {mentioned ? 'YES' : 'NO'}
            </span>
            {rankPosition !== null && (
              <span className="text-sm text-on-surface-variant">· Rank #{rankPosition}</span>
            )}
            {sentiment && (
              <span className="text-xs px-2 py-0.5 rounded bg-surface-container-high text-on-surface-variant font-mono">
                {sentiment}
              </span>
            )}
          </div>

          {contextSnippet && (
            <div>
              <p className="text-xs font-mono text-outline uppercase tracking-widest mb-2">Exact quote about your brand</p>
              <p className="text-sm text-on-surface-variant leading-relaxed bg-surface-container-high rounded-lg px-4 py-3">
                {contextSnippet}
              </p>
            </div>
          )}

          {competitorMentions.length > 0 && (
            <div>
              <p className="text-xs font-mono text-outline uppercase tracking-widest mb-2">
                {mentioned ? 'Also mentioned' : 'Others mentioned'}
              </p>
              <ul className="space-y-1">
                {competitorMentions.map((c) => (
                  <li key={c} className="text-sm text-on-surface-variant">• {c}</li>
                ))}
              </ul>
            </div>
          )}

          {!aiAnswer && !contextSnippet && competitorMentions.length === 0 && (
            <p className="text-sm text-outline italic">No additional details returned by the model.</p>
          )}
        </div>
      </div>
    </div>
  )
}
